'use strict';

var React = require('react');

var SvgProductsFilledMinor = function SvgProductsFilledMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.025 4h1.725a3.25 3.25 0 0 1 3.25 3.25v1.938a2.5 2.5 0 0 1-.765 1.8l-4.468 4.308a2.5 2.5 0 0 1-3.503-.032l-2.528-2.528a2.5 2.5 0 0 1-.032-3.503l4.161-4.315a3 3 0 0 1 2.16-.918Zm1.975 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }));
};
SvgProductsFilledMinor.displayName = "ProductsFilledMinor";

exports.SvgProductsFilledMinor = SvgProductsFilledMinor;
